import createAction from "redux-actions/es/createAction";
import { getScenarioList as api } from "../api/index";
import { getStatusJenkinsJob as getScenarioUpdateRowApi , getLatestJobId as getLatestJobIdApi } from "../api/index";
import { getScenarioUpdateRow as updateRowApi } from "../api/index";
import { checkAuth as authApi } from "../api/index";
import { getjenkinJobStatus as getjenkinJobStatusApi } from "../api/index";
import { executeJenkinsJob as executeJenkinsJobApi } from "../api/index";
import { auth, loadInitClientDataFail } from "../../../actions/authActions";
import {redirectFromPushStatus} from '../../customer/actions/index';
import { toastr } from "react-redux-toastr";

export const jenkinJobStatus = createAction("JENKIN_JOB_STATUS_START");
export const jenkinJobStatusSuccess = createAction("JENKIN_JOB_STATUS_SUCCESS");
export const jenkinJobStatusUpdate = createAction("JENKIN_JOB_STATUS_UPDATE");
export const updateJobStatusSuccess = createAction("JOB_ID_UPDATE");
export const jenkinJobStatusSingleRowUpdate = createAction("JENKIN_JOB_STATUS_SINGLE_ROW_UPDATE");
export const jenkinJobStatusFail = createAction("JENKIN_JOB_STATUS_FAIL");
export const jenkinJobStatusClear = createAction("JENKIN_JOB_STATUS_CLEAR");

export const scenarioList = createAction("SCENARIO_FETCH_START");
export const scenarioListSuccess = createAction("SCENARIO_FETCH_SUCCESS");
export const scenarioListUpdateForce = createAction("SCENARIO_FETCH_UPDATE_FORCE");
export const scenarioListUpdate = createAction("SCENARIO_FETCH_UPDATE");
export const scenarioListFail = createAction("SCENARIO_FETCH_FAIL");

export const jenkinsJobPre = createAction("JENKIN_JOB_PRE_START");
export const jenkinsJobPreSuccess = createAction("JENKIN_JOB_PRE_SUCCESS");
export const jenkinsJobPreFail = createAction("JENKIN_JOB_PRE_FAIL");

export const jenkinsJobPost = createAction("JENKIN_JOB_POST_START");
export const jenkinsJobPostSuccess = createAction("JENKIN_JOB_POST_SUCCESS");
export const jenkinsJobPostFail = createAction("JENKIN_JOB_POST_FAIL");

export const fetchTokenFail = createAction("FETCH_TOKEN_FAIL");
export const tokenErrorClear = createAction("TOKEN_ERROR_CLEAR");




export const fetchScenarioList =   (values) => {
  return  async (dispatch) => {
     await api(values)
      .then((res) => {
        //  res.data[1].transactionData[0].preUpgradeExecutionReport="In-Progress";
         dispatch(scenarioListSuccess(res.data));
      })
      .catch((err, res) => {
        dispatch(scenarioListFail(err));
        // ErrorFound("Not a valid request,Please verify");
      });
  };
};
export const getLatestJobId =   (values) => {
  return  async (dispatch) => {
     await getLatestJobIdApi(values)
      .then((res) => {
        //  res.data[1].transactionData[0].preUpgradeExecutionReport="In-Progress";
         dispatch(scenarioListSuccess([res.data]));
      })
      .catch((err, res) => {
        dispatch(scenarioListFail(err));
        // ErrorFound("Not a valid request,Please verify");
      });
  };
};

export const clearLatestJobId =   () => {
  return  async (dispatch) => {
    dispatch(scenarioListSuccess([]));
    
  };
};
export const getLatestJobIdUpdateForce =   (data) => {
  return  async (dispatch) => {
    dispatch(scenarioListUpdate(data));
  };
};

export const fetchScenarioSingleRow =   (values) => {
  return  async (dispatch) => {
     await updateRowApi(values)
      .then((res) => {
        //  res.data[1].transactionData[0].preUpgradeExecutionReport="In-Progress";
         dispatch(scenarioListSuccess(res.data));
      })
      .catch((err, res) => {
        dispatch(scenarioListFail(err));
        // ErrorFound("Not a valid request,Please verify");
      });
  };
};

export const updatedSingleRow =   (values) => {
  return  async (dispatch) => {
   await updateRowApi(values)
      .then((res) => {
        let dataCopy=res.data[0];
        dispatch(updateJobStatusSuccess(values.jobId));
        if(dataCopy.jobId===values.jobId && 
          (dataCopy.transactionData[0]['upgradeStatus']=== "Pre-upgrade Execution Completed"||dataCopy.transactionData[0]['upgradeStatus']=== "Post-upgrade Execution Completed")){
            let pjName={projectName:values.projectName}
            dispatch(fetchScenarioList(pjName));
            dispatch(updateJobStatusSuccess(''));
         }else{
          setTimeout(()=>{

            dispatch(updatedSingleRow(values));
          },30000); 
         }
      })
      .catch((err, res) => {
        dispatch(scenarioListFail(err));
        ErrorFound("Not a valid request,Please verify");
      });
  };
};

export const fetchUpdatedScenarioList =   (values) => {
  return  async (dispatch) => {
   await getScenarioUpdateRowApi(values)
      .then((res) => {
        if(res.data.jobId===values.pushUpgradeJobId){
          dispatch(scenarioListUpdate(res.data));
        }
      })
      .catch((err, res) => {
        dispatch(scenarioListFail(err));
        ErrorFound("Not a valid request,Please verify");
      });
  };
};
const ErrorFound = (res) => {
  return toastr.error("Unknown Error Occurred", res);
};
export const getAuth =  (data) => {
  return async (dispatch) => {
   await  authApi(data.token)
      .then((res) => {
        if (res.data === "Token is Valid" && res.status===200) {
          let payload = {
            token: data.token,
            refreshToken: data.token,
            isSignUp: false,
          };
          dispatch(auth(payload));
          let obj={
            projectName:data.projectName
          }
          // dispatch(fetchScenarioList(obj));
        }
      })
      .catch((err, res) => {
        dispatch(fetchTokenFail(err?.response?.data));
        // window.location.href=window.location.origin+'/error';
      });
  };
};


export const  executeJenkinsJobForPre= (data)=>{
  return async (dispatch)=>{
     await executeJenkinsJobApi(data).then((res)=>{
     if(res.data===201){
       dispatch(jenkinsJobPreSuccess(res.data)); 
      //  dispath(fetchScenarioList({projectName:data?.projectName}));
     }
    }).catch((err)=>{
      dispatch(jenkinsJobPreFail(err)); 
    })
  }

}

export const  executeJenkinsJobForPost=  (data)=>{
  return async (dispatch)=>{
     await executeJenkinsJobApi(data).then((res)=>{
       if(res.data===201){
         dispatch(jenkinsJobPostSuccess(res.data)); 
       }
    //  dispath(fetchScenarioList({projectName:data?.projectName}));
    }).catch((err)=>{
      dispatch(jenkinsJobPostFail(err)); 
    })
  }
}
// getjenkinJobStatus
export const  getjenkinJobStatus=  (data)=>{
  return async (dispatch)=>{
     await getjenkinJobStatusApi(data).then((res)=>{
         dispatch(jenkinJobStatusSuccess(res.data)); 
    }).catch((err)=>{
      dispatch(jenkinJobStatusFail(err)); 
    })
  }

}

export const redirectToEFB=()=>{
  return async (dispatch)=>{
      dispatch(redirectFromPushStatus(true));
 }
}



// export const  getJobIdUpadte=  (data)=>{
//   return async (dispatch)=>{
//         await dispatch(updateJobStatusSuccess(data)); 
//   }

// }

// let apiCall="https://frameworkservices-dev.apttuscloud.io/versioncontroller/upgrade/update-status?projectName=CLM&jobId="+data.refId+"&upgradeStatus="+data.status+"&upgradeStatusNote="+data.message+"&session="+props.post

// export const  executeJenkinsJobForPreEmail=  (data)=>{
//   return async (dispatch)=>{
//     await executeJenkinsJobApi(data).then((res)=>{
//       dispatch(JenkinsJobPostSuccess(res.data)); 
//     }).catch((err)=>{
//       dispatch(JenkinsJobPreError(res.data)); 
//     })
//   }

// }